import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type {
    CampaignDemandConfigExportParams,
    CampaignDemandConfigPagingParams,
    CampaignDemandSubmitVo,
    Page
} from "@zhihaoscm/entity";

export class CampaignDemandService extends BaseService<unknown, unknown, unknown, unknown> {
    /**
     * 分页查询活动需求配置
     */
    public async getPaging(params: CampaignDemandConfigPagingParams): Promise<Page<CampaignDemandSubmitVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    /**
     * 导出活动需求配置
     */
    public async export(params: CampaignDemandConfigExportParams, filename: string) {
        const response = (await this.service.get(`${this.path}/export`, {
            params,
            responseType: "blob"
        })) as Blob;

        const url = window.URL.createObjectURL(response);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        return response;
    }

    /**
     * 删除活动需求配置
     */
    public async delete(id: number) {
        await this.service.delete(`${this.path}/${id}`);
    }

    /**
     * 修改需求备注
     */
    public async updateRemark(form: { id: number; remark: string }) {
        await this.service.put(`${this.path}/remark`, form);
    }
}

export const campaignDemandService = new CampaignDemandService("/admin/campaign-demand", request.service);
